import { Link, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { fCoins, fCurrency } from "src/utils/formatNumber";
import { fDateTime } from "src/utils/formatTime";
import Iconify from "../iconify";
import CoinIcon from "../icons/CoinIcon";
import UserXpLevelIcon from "../icons/UserXpLevelIcon";
import UserLevelChip from "../level/UserLevelChip";
import Scrollbar from "../scrollbar";

export default function UsersTable(props) {
	return (
		<Scrollbar>
			<TableContainer component={Paper}>
				<Table sx={{ minWidth: 650 }} aria-label="simple table">
					<TableHead>
						<TableRow>
							<TableCell>User ID</TableCell>
							<TableCell>Username</TableCell>
							<TableCell>User Value</TableCell>
							<TableCell>Name</TableCell>
							<TableCell>Email</TableCell>
							<TableCell>Enabled</TableCell>
							<TableCell>Balance</TableCell>
							<TableCell>Revenue</TableCell>
							<TableCell>XP Level</TableCell>
							<TableCell>Signup</TableCell>
							<TableCell align="right"></TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{props.users.map((row, index) => (
							<TableRow
								key={index}
								sx={{
									"&:last-child td, &:last-child th": { border: 0 },
								}}
							>
								<TableCell component="th" scope="row">
									{row.userId}
								</TableCell>
								<TableCell component="th" scope="row">
									{row.username.toString().length > 10 ? `${row.username.toString().slice(0, 10)}...` : row.username.toString()}
								</TableCell>
								<TableCell component="th" scope="row">
									<UserLevelChip level={row.userLevelStats?.topPct} />
								</TableCell>
								<TableCell component="th" scope="row">
									{row.firstName} {row.lastName}
								</TableCell>
								<TableCell component="th" scope="row">
									<Link
										href={`/dashboard/profile?user_id=${row.userId}`}
										sx={{
											textDecoration: "none",
											color: "primary.main",
											"&:hover": { textDecoration: "underline" },
										}}
									>
										{row.email.toString().length > 20 ? `${row.email.toString().slice(0, 20)}...` : row.email.toString()}
									</Link>
								</TableCell>
								<TableCell component="th" scope="row">
									{row.isEnabled ? (
										<Iconify icon={"eva:checkmark-circle-2-outline"} sx={{ color: "green" }} />
									) : (
										<Iconify icon={"eva:close-circle-outline"} sx={{ color: "red" }} />
									)}
								</TableCell>
								<TableCell component="th" scope="row">
									<div
										style={{
											display: "flex",
											alignItems: "center",
											gap: "4px",
										}}
									>
										<CoinIcon />
										{fCoins(row.balance)}
									</div>
								</TableCell>
								<TableCell component="th" scope="row">
									{fCurrency(row.revenue / 100)}
								</TableCell>
								<TableCell component="th" scope="row">
									<UserXpLevelIcon levelName={row.levelName} />
								</TableCell>
								<TableCell component="th" scope="row">
									{fDateTime(row.createdAt)}
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</Scrollbar>
	);
}
